import React from 'react';
import { Link, Stack, Text } from 'library/ui';
import { format12HourTime } from 'shared/Dates';
import CardInfo from './CardInfo';
import { useHistory } from 'react-router-dom';
import { IHourReport } from 'internal/payments/HourReportModels';
import WatchLaterIcon from '@mui/icons-material/WatchLater';

export default function HourReportInfo({ hourReport, timezone }: { hourReport: IHourReport; timezone: string }) {
    const history = useHistory();

    const businessLocationId = hourReport.business_location as unknown as number;

    return (
        <Stack gap="sm" align="start">
            <Stack gap="none" align="start">
                {hourReport.start ? (
                    <CardInfo
                        title="Clocked Hours:"
                        content={`${format12HourTime(hourReport.start, timezone)}${hourReport.end ? ` - ${format12HourTime(hourReport.end, timezone)}` : ''}${hourReport.approved_break ? ` (${hourReport.approved_break} min break)` : ''}`}
                    />
                ) : hourReport.late_minutes ? (
                    <Text weight="bold" tone="error">{`Running ${hourReport.late_minutes} minutes late`}</Text>
                ) : null}
                <Text size="xs">{`${hourReport.hours_worked ? `${hourReport.hours_worked.toString()} hours worked` : ''}`}</Text>
            </Stack>
            {hourReport.start && hourReport.end && !hourReport.paid ? (
                <CardInfo title="Status:" content={'Pending'} />
            ) : null}
            {hourReport.start && !hourReport.paid ? (
                <Link
                    onClick={() => history.push(`timesheets?location=${businessLocationId}&page=1`)}
                    icon={<WatchLaterIcon style={{ fontSize: 18 }} />}
                >
                    Edit clocked hours
                </Link>
            ) : null}
        </Stack>
    );
}
